import { useTranslation } from "react-i18next";
import { Wrench, Clock, Mail } from "lucide-react";

export default function MaintenancePage({ settings }) {
  const { i18n } = useTranslation();
  const fr = (i18n.language || "en").startsWith("fr");
  const s = settings || {};
  const title = fr
    ? (s.maintenance_title_fr || "DJILU est temporairement en maintenance")
    : (s.maintenance_title_en || "DJILU is temporarily under maintenance");
  const message = fr
    ? (s.maintenance_message_fr || "Nous améliorons la plateforme afin de vous offrir une meilleure expérience.\n\nVeuillez revenir un peu plus tard.")
    : (s.maintenance_message_en || "We are improving the platform to provide you with a better experience.\n\nPlease check back soon.");
  const returnTime = s.maintenance_return_time;
  const supportEmail = s.maintenance_support_email;
  const showLogo = s.maintenance_show_logo !== false;
  const showSocial = s.maintenance_show_social !== false;

  const socials = [
    ["social_x", "X"], ["social_facebook", "Facebook"], ["social_instagram", "Instagram"],
    ["social_youtube", "YouTube"], ["social_tiktok", "TikTok"],
  ].filter(([k]) => s[k]);

  return (
    <div className="min-h-screen bg-[#050814] flex items-center justify-center px-6" data-testid="maintenance-page">
      <div className="max-w-lg w-full text-center">
        {showLogo && (
          <img src={s.logo_url || "/djilu-logo.png"} alt="DJILU" className="h-14 w-auto object-contain mx-auto mb-8" />
        )}
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#FFC928]/10 border border-[#FFC928]/25 mb-6">
          <Wrench className="text-[#FFC928]" size={28} />
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold text-white mb-4" data-testid="maintenance-title">{title}</h1>
        <p className="text-[#94A3B8] text-sm sm:text-base whitespace-pre-line leading-relaxed">{message}</p>

        {returnTime && (
          <div className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-white/[0.04] border border-white/[0.08] text-sm text-white">
            <Clock size={15} className="text-[#FFC928]" />
            {fr ? "Retour estimé : " : "Estimated return: "}{returnTime}
          </div>
        )}

        {supportEmail && (
          <div className="mt-4">
            <a href={`mailto:${supportEmail}`} className="inline-flex items-center gap-2 text-sm text-[#FFC928] hover:underline">
              <Mail size={15} /> {supportEmail}
            </a>
          </div>
        )}

        {showSocial && socials.length > 0 && (
          <div className="mt-8 flex items-center justify-center gap-4">
            {socials.map(([k, label]) => (
              <a key={k} href={s[k]} target="_blank" rel="noopener noreferrer"
                className="text-xs text-[#94A3B8] hover:text-white transition-colors">{label}</a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
